import easing from 'jquery.easing';
import { gsap } from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
import Swiper, {Navigation} from 'swiper';
import swiper from 'swiper/bundle';
import 'swiper/css';
import 'swiper/css/bundle';
import 'swiper/css/navigation';
// import MicroModal from 'micromodal';

export class App {
  constructor(){
    this.html = document.documentElement;
    this.body = document.body;
    this.page = document.getElementById('site');
    this.ua = this.isSp(this);
    this.spd = 900;
    this.ease = "easeInOutExpo";
    this.winW = window.innerWidth;
    this.winH = window.innerHeight;
    // this.header = document.getElementById('header');
    this.footer = document.querySelector('.footer');
    // this.headerH = this.header.offsetHeight;
    // this.gnav = this.header.querySelector('.gnav');
    // this.gnav_a = this.gnav.querySelectorAll('a');


    this.ww = 768;
    this.open = false;
    this.sp = true;

    // gsap.registerPlugin(ScrollTrigger)

  }
  init(){

    // console.log(this.ua)
    

		// this.makeSp();
    // this.makeParts();
    this.make_swp();
    // this.resize();

    window.addEventListener('load', (e) => {
      // this.setgsap();
      const _this = this;
      this.page.classList.add('on');
      $('.spinner').fadeOut('slow', function(){
        $(this).remove();
        // this.addEventListener();
        // _this.resize();
        _this.events();
        setTimeout((e) => {
          _this.page.classList.add('go')
        }, 100);
      });
    });
  }
	makeSp(){
		this.btn_hum = document.createElement('div');
		this.btn_hum.classList.add('btn_hum')
		this.btn_hum.classList.add('sp')
		this.btn_hum.innerHTML = `<div class="btn_inner"><span class="bar"></span><span class="bar"></span><span class="bar"></span></div>`;
		this.header.appendChild(this.btn_hum);

    this.gback = document.createElement('div');
    this.gback.classList.add('gback');
    this.gnav.appendChild(this.gback)
	}
  makeParts(){
  }

  setgsap(){

    gsap.from('.listL', {
      x:-30,
      duration:1,
      delay:1.4,
      ease: "power2.out",
      stagger: {
        from: "start",
        amount: .8
      },
      opacity:0
    })
    
    gsap.from('.aboutList-item', {
      y:20,
      duration:1,
      ease: "power2.out",
      opacity:0,
      scrollTrigger: {
        trigger: '.aboutList-item',
        start: "top bottom-=30%",
        // markers:true
      },
      stagger: {
        from: "start",
        amount: .8
      }
    })
    
    gsap.from('.diffList-item', {
      y:20,
      duration:1,
      ease: "power2.out",
      opacity:0,
      scrollTrigger: {
        trigger: '.diffList-item',
        start: "top bottom-=30%",
        // markers:true
      },
      stagger: {
        from: "start",
        amount: .8
      }
    })
   
   
    gsap.from('.pList-item', {
      x:-10,
      duration:2,
      ease: "power2.out",
      opacity:0,
      scrollTrigger: {
        trigger: '.pList-item',
        start: "top bottom-=30%",
        // markers:true
      },
      stagger: {
        from: "start",
        amount: 1,
        onStart:function(){
          this._targets[0].classList.add('active')
        }
      },
      add: () => {
        //console.log(this)
      }
    })

    gsap.from('.topT', {
      y:20,
      duration:1,
      opacity:0,
      ease:"power2.out",
      delay:1
    })

    gsap.from('.cho-katsu', {
      opacity:0,
      duration:1,
      delay:1.5,
      ease:"power2.out",
      onComplete: function(){
        this._targets[0].classList.add('active')
      }
    })

    gsap.from('.kona', {
      opacity:0,
      duration:.7,
      delay:.5,
      ease:"power2.out",
      scrollTrigger: {
        trigger: '.kona',
        start: "top bottom-=30%",
        // markers:true
      },
      onComplete: function(){
        this._targets[0].classList.add('active')
      }
    })
    
    gsap.from('.chokatsu', {
      opacity:0,
      duration:.7,
      delay:.5,
      ease:"power2.out",
      scrollTrigger: {
        trigger: '.chokatsu',
        start: "top bottom-=30%",
        // markers:true
      },
      onComplete: function(){
        this._targets[0].classList.add('active')
      }
    })

    const scT = document.querySelectorAll('.scT');

    scT.forEach(
      _sct => {
        gsap.from(_sct, {
          y:20,
          opacity:0,
          // delay:.5,
          duration:1,
          scrollTrigger: {
            trigger:_sct,
            start: "top bottom-=30%",
            // markers:true
          },
          onComplete: function(){
            // console.log(this)
            // console.log(_sct)
            _sct.classList.add('active');
          }
        }
      )
      }
    )

    const scO = document.querySelectorAll('.scO');

    scO.forEach(
      _sco => {
        gsap.from(_sco, {
          opacity:0,
          // delay:.5,
          duration:1,
          scrollTrigger: {
            trigger:_sco,
            start: "top bottom-=30%",
            // markers:true
          },
          onComplete: function(){
            // console.log(this)
            // console.log(_sco)
            _sco.classList.add('active');
          }
        }
      )
      }
    )
    
    const scTd = document.querySelectorAll('.scTd');

    scTd.forEach(
      _sctd => {
        gsap.from(_sctd, {
          opacity:0, delay:1,duration:1,
          scrollTrigger: {
            trigger:_sctd,
            start: "top bottom-=30%",
            // markers:true
          },
          onComplete: function(){
            _sctd.classList.add('active');
          }
        })
      }
    )

    // gsap.from('.scT', {
    //   y:30,
    //   duration:1,
    //   ease:"power2.out",
    //   opacity:0,
    //   scrollTrigger: {
    //     trigger: '.scT',
    //     start: 'top bottom-=30%',
    //     markers:true
    //   }
    // })
  }

  events(){

    // MicroModal.init({
    //   disableScroll:true,
    //   onClose: (modal,triger) => {
    //     const _md = modal.closest('.modal_container');
    //     if(_md.classList.contains('sw')){
    //       const _key = _md.dataset.sw;
    //       this.sw_arr[_key].autoplay.start();
    //       // console.log(_md)
    //     }

    //   }
    // });

    // this.make_swp();

    
    
    // const paras = document.querySelectorAll('.para');
    // const scR = document.querySelectorAll('.scR');
    // const scL = document.querySelectorAll('.scL');
    // const scT = document.querySelectorAll('.scT');
    // const scO = document.querySelectorAll('.scO');

    

    // scL.forEach(
    //   _scl => {
    //     gsap.fromTo(_scl, {
    //       x:"-30",
    //       opacity:0
    //     },{
    //       x:"0",
    //       opacity:1,
    //       duration:1,
    //       scrollTrigger: {
    //         trigger:_scl,
    //         start: "top bottom-=20%",
    //       }
    //     })
    //   }
    // )

    // scT.forEach(
    //   _sct => {
    //     gsap.fromTo(_sct, {
    //       y:"30",
    //       opacity:0
    //     },{
    //       y:"0",
    //       opacity:1,
    //       // delay:.5,
    //       duration:1,
    //       scrollTrigger: {
    //         trigger:_sct,
    //         start: "top bottom-=30%"
    //       }
    //     })
    //   }
    // )
    // scTd.forEach(
    //   _sctd => {
    //     gsap.fromTo(_sctd, {
    //       y:"40px",
    //       opacity:0
    //     },{
    //       y:"0",
    //       opacity:1,
    //       delay:1,
    //       duration:1.2,
    //       scrollTrigger: {
    //         trigger:_sctd,
    //         start: "top bottom-=10%"
    //       }
    //     })
    //   }
    // )
    // srR.forEach(
    //   _srr => {
    //     gsap.fromTo(_srr, {
    //       x:"15%",
    //       rotate:"30deg",
    //       opacity:0
    //     },{
    //       x:"0",
    //       rotate:"0deg",
    //       opacity:1,
    //       delay:.5,
    //       duration:1.2,
    //       scrollTrigger: {
    //         trigger:_srr,
    //         start: "top bottom-=10%"
    //       }
    //     })
    //   }
    // )
    // srL.forEach(
    //   _srl => {
    //     gsap.fromTo(_srl, {
    //       x:"-15%",
    //       rotate:"-30deg",
    //       opacity:0
    //     },{
    //       x:"0",
    //       rotate:"0deg",
    //       opacity:1,
    //       delay:.5,
    //       duration:1.2,
    //       scrollTrigger: {
    //         trigger:_srl,
    //         start: "top bottom-=20%"
    //       }
    //     })
    //   }
    // )


    // this.gnav_a.forEach(
    //   _btn_a => {
    //     _btn_a.addEventListener('click', (e) => {
    //       if(this.sp){
    //         this.menuClose();
    //       }
    //     })
    //   }
    // )

    // this.btn_hum.addEventListener('click', (e) => {
    //   if(this.open){
    //     this.menuClose();
        
    //   }else{
    //     this.menuOpen();
        
    //   }

    //   this.gback.addEventListener('click', (e) => {
    //     this.menuClose();
    //   })
    // })



    // window.addEventListener('resize', (e) => {this.resize();})

    
    const atags = document.querySelectorAll('a[href^="#"]');
    atags.forEach(
      _atag => {
        // console.log(_atag)
        _atag.addEventListener('click', (e) => {
          e.preventDefault();
          let href = e.currentTarget.getAttribute('href')
          if(href=="" || href=="#"){
            href = "top"
            this.spd = 1200
          }
          console.log(href)
          href = href.replace("#","")
          
          const tar = document.getElementById(href)

          this.anim(tar);
        })
      }
    )

    const mediaQueryList = window.matchMedia('(min-width:'+this.ww+'px)');
    const listener = (e) => {
      if(e.matches){
        this.sp=false;
        
      }else{
        this.sp = true;
      }
      this.queryMatch();
    }
    mediaQueryList.addEventListener('change', listener);

    listener(mediaQueryList);





    //micromodal
    
    

  }

  queryMatch(){

    // console.log(this.sp);
    // if(this.sp){ //sp
    //   this.header.classList.add('in');
    // }else{
    //   this.header.classList.remove('in');
    //   this.header.classList.remove('on');
    //   this.btn_hum.querySelector('.bar:nth-child(1').style.animationName=""
    //   this.btn_hum.querySelector('.bar:nth-child(3').style.animationName = ""
    //   this.open=false;
    // }
  }
  menuOpen(){
    this.open = true;
    this.header.classList.add('on')
  }
  menuClose(){
    // console.log('close')
    this.open = false;
    this.header.classList.remove('on');
    // this.btn_hum.querySelector('.bar:nth-child(1').style.animationName='bar1'
    // this.btn_hum.querySelector('.bar:nth-child(3').style.animationName = "bar3"
  }
  make_swp(){
    // console.log('mkswp')

    const _swp_obj = {
      loop:true,
      speed: 1000,
      slidesPerView:1.3,
      centeredSlides:true,
      spaceBetween:30,
      // modules: [Navigation],
      // autoplay: {
      //   delay: 5000,
      //   disableOnInteraction:false,
      //   waitForTransition: false
      // },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      // effect:'fade',
      // fadeEffect: {
      //   crossFade: true
      // },
      breakpoints: {
        500:{
          slidesPerView:1.5,
          spaceBetween:30
        }
      },
      on: {
        slideChange:(swiper) => {
          // console.log(swiper)
        },
        slideChangeTransitionStart: (swiper) => {
          // console.log("start="+swiper.realIndex)
          // animStart();
        },
        // slidePrevTransitionEnd: (swiper) => {
        //   console.log("prev="+swiper.realIndex)
        // },
        slideChangeTransitionEnd:(swiper) => {
          // console.log("end="+swiper.realIndex);
          // animEnd();
        }
      }
    }

    this.sw_arr = [];
    let sw_cnt = 1;
    this.swipers = document.querySelectorAll('.swp');
    // console.log(this.swipers)
    this.swipers.forEach(
      _swp => {
        const _obj = {..._swp_obj}//コピー
        if(_swp.classList.contains('support')){
          _obj.slidesPerView = 1
          // _obj.spaceBetween = 20;
          _obj.breakpoints = {500: {slidesPerView:1,spaceBetween:50}}
          // console.log(_swp)
        }
        // console.log(_obj)
        const _id = "sw"+sw_cnt
        _swp.id = _id
        this.sw_arr[_id]= new Swiper(_swp,_obj)
        sw_cnt++;
      }
    )
    
    // console.log(this.sw_arr)
    // this.slides = document.querySelectorAll('.swiper-slide');
    // this.slides.forEach(
    //   _sl => {
    //     _sl.addEventListener('click', (e) => {
    //       const _id = e.currentTarget.closest('.swiper').id;
    //       const _sw = this.sw_arr[_id]
    //       _sw.autoplay.stop();
    //       console.log(_sw);
    //     })
    //   }
    // )

    // this.closes = document.querySelectorAll('[data-micromodal-close]');
    // this.closes.forEach(
    //   _close => {
    //     _close.addEventListener('click', (e) => {
          
    //       console.log(e.target)
    //       const _md = e.currentTarget.closest('.modal_container');
    //       if(_md.classList.contains('sw') || e.currentTarget.classList.contains('modal__container')){
    //         if(e.currentTarget.dataset.micromodalClose === ''){
    //           this.sw_arr[_md.dataset.sw].autoplay.start()
    //           console.log('true')
    //         }else{
    //           console.log('false')
    //         }
    //       }
    //       // e.stopPropagation();
    //     })
    //   }
    // )
   
  }
  anim(_t,_tt=this.spd) {
    const rect = _t.getBoundingClientRect();
    const scT = window.pageYOffset || document.documentElement.scrollTop;
    let targetT  = rect.top;

    targetT = rect.top + scT;// - this.headerH;

    // console.log(scT,this.headerH);
    $('html,body').animate({
      scrollTop: targetT
    }, _tt, this.ease);
  }
  isSp(_t){
    let _ua_ar=[];
    let _ua;
    if(navigator.userAgent.match(/iPhone|iPad|iPod|Android.+Mobile/)){
      _ua_ar.push("mobile");
      _ua = "mobile";
      if(navigator.userAgent.match(/iPhone|iPod|Android.+Mobile/)){
        _ua_ar.push("m_sp");
      }
      if(navigator.userAgent.match(/iPad/)){
        // _ua_ar.push("m_pd");
      }
      // _t.makeSp();
      //console.log(_t);
      console.log(navigator.userAgent);
    }else{
      _ua = "other";
      _ua_ar.push("other");
    }
    _ua_ar.forEach(_u => {
      _t.body.classList.add(_u);
    });
    //_t.body.classList.add(_ua_ar);
    return _ua;
  }
  resize(){
    this.getsize();
    // this.html.style.setProperty('--hh', this.headerH + "px");
  }
  getsize(){
    this.winW = window.innerWidth;
    this.winH = window.innerHeight;
    // this.headerH = this.header.offsetHeight;
  }
}
